var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3467723",
    d: "M53 57.332V34.332C53 33.2275 52.1046 32.332 51 32.332H20C18.8954 32.332 18 33.2275 18 34.332V57.332",
    stroke: "#747E87",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1441",
    cx: 35.8648,
    cy: 19.9537,
    r: 5.9537,
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfile);
export default __webpack_public_path__ + "static/media/icon-user-profile.cdc19d5643777494958caf9ca31c5476.svg";
export { ForwardRef as ReactComponent };